<template>
  <div v-if="chat.message"
       :class="[{'flex-row-reverse' : chat.type === 0 || type === 'customer-agent', 'principal': slotInUse, 'force-revert-flex': type === 'customer-customer' || type === 'agent-customer'}]"
       class="flex items-start"
  >
    <div :class="[{'principal': slotInUse}]" style="display: flex; flex-direction: row; align-items: center;">
      <div
          style="float: right;"
          class="msg break-words relative shadow-md rounded py-3 px-4 mb-2 rounded-lg"
          :class="{
            'bg-primary-gradient text-white': (!chat.type) && !chat.is_bot_message,
            'text-black': type === 'customer-customer' || chat.type === 1 && type === 'agent-customer',
            'is-bot-message text-white': !chat.type && chat.is_bot_message,
            'text-white': type === 'agent-customer' && chat.type === 0,
            'is-comment-message text-white': chat.tag_type === 'comment',
            'border border-solid border-grey-light bg-white': chat.type
          }"
      >
        <div v-if="chat.tag_type === 'image' || chat.tag_type === 'sticker'">
          <img :src="chat.message" style="max-width: 100%;"/>
        </div>

        <div v-else-if="chat.tag_type === 'audio'">
          <audio controls style="max-width: 100%;">
            <source :src="chat.message"/>
          </audio>
        </div>

        <div v-else-if="chat.tag_type === 'video'">
          <video controls height="240" width="100%">
            <source :src="chat.message" type="video/mp4">
          </video>
        </div>

        <div
            v-else-if="
              chat.tag_type === 'document'
              || chat.tag_type === 'doc'
              || chat.tag_type === 'pdf'
            "
            style="cursor: pointer;"
            @click="downloadDocument(chat.message, chat.document_name, chat.document_mimetype)"
        >
          <strong>{{ chat.document_name }}</strong>
          <div class="flex mt-2 mb-2">
            <feather-icon icon="DownloadIcon"/>
            <span class="ml-3 self-center"> Baixar documento</span>
          </div>
        </div>

        <div v-else style="white-space: pre-line;">
          <div class="msg-render" v-html="stylizeMessage(chat.message)"></div>
        </div>

        <div align="right" class="chat-footer">
          <small>
            {{ chat.is_temp ? 'Enviando...' : sentAtMessage(chat.created_at) }}
          </small>
          <div v-if="!chat.type" class="chat-ack-container">
            <i :class="'chat-ack-icon material-icons ' + iconColor(chat)">
              {{ icon(chat) }}
            </i>
          </div>
        </div>

        <div v-if="chat.type && type !== 'customer-agent' && !hiddenReply">
          <vs-icon class="reply-message" icon="icon-arrow-right" icon-pack="feather" title="Responder" @click="reply(chat)"/>
        </div>

        <div v-if="(!chat.type && type !== 'agent-agent' || !chat.type && principalIndex) && !hiddenReply">
          <vs-icon class="reply-message" icon="icon-arrow-right" icon-pack="feather" title="Responder" @click="reply(chat)"></vs-icon>
        </div>

        <slot></slot>
      </div>
      <div style="clear: both;"></div>
    </div>
  </div>
</template>

<script>
import {getTimeZone, stylizeMessage} from '@/utils'

import axios from 'axios'
import VsDropdown from "@/components/vs-dropdown/dropdown.vue";
import VsDropdownMenu from "@/components/vs-dropdown/dropdown-menu.vue";
import VsDropdownItem from "@/components/vs-dropdown/dropdown-item.vue";

export default {
  name: 'InternalChatLogItem',
  data() {
    return {};
  },
  components: {
    VsDropdown,
    VsDropdownMenu,
    VsDropdownItem,
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    type: {
      default: null,
      type: String
    },
    chat: {
      default: null,
      validator: prop => typeof prop === 'object' || prop === null
    },
    hiddenReply: {
      type: Boolean,
      default: false
    },
    principalIndex: {
      type: Number,
      default: null
    }
  },
  computed: {
    slotInUse() {
      return this.$slots.default
    }
  },
  methods: {
    stylizeMessage,
    icon(chat) {
      if (chat.is_temp) {
        return 'schedule'
      }

      if (chat.ack === -1) {
        return 'report_problem'
      }
      if (chat.ack === 0) {
        return 'schedule'
      }
      if (chat.ack === 1) {
        return 'done'
      }
      if (chat.ack === 2) {
        return 'done_all'
      }
      if (chat.ack === 3) {
        return 'done_all'
      }

      if (chat.created_at) {
        return 'check'
      }

      return '';
    },
    iconColor(chat) {
      if (chat.ack === 3) {
        return 'chat-ack-icon-blue'
      }
      return 'chat-ack-icon-gray';
    },
    reply(internalChat) {
      this.$store.dispatch('internalChatMessages/setReplyMessage', internalChat);
    },
    scrollToBottom() {
      this.$nextTick(() => {
        this.$parent.$el.scrollTop = this.$parent.$el.scrollHeight
      });
    },
    sentAtMessage(sentAt) {
      if (!sentAt) { return '' }
      return getTimeZone(sentAt)
    },
    downloadDocument(url, documentName, documentMimetype) {
      axios.get(url, { responseType: 'blob' }).then(res => {
        let blob = new Blob(
          [res.data],
          {type: `${documentMimetype};charset=utf-8;`}
        )
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = documentName
        link.click()
        window.URL.revokeObjectURL(link.href)
      })
    }
  },
  async mounted() {
    this.scrollToBottom();
  }
}
</script>

<style lang="scss">
.chat-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.chat-ack-icon-gray {
  color: #c4c4c4;
}

.chat-ack-icon-blue {
  color: #44ffff;
}

.chat-ack-container {
  display: inline-block;

  .chat-ack-icon {
    font-size: 13px;
    margin-left: 5px;
  }
}

.text-black {
  color: #6B7589 !important;
}

.force-revert-flex {
  flex-direction: row !important;
}

.chat-message {
  white-space: pre-line;

  code {
    background-color: transparent;
  }

  del {
    text-decoration: line-through;
    text-decoration-thickness: 1px;
  }
}

.msg {
  max-width: 20rem;
}

.reply-message {
  position: absolute !important;
  top: -3px;
  right: -8px;
  background: #89c5ed;
  color: #ffff;
  border-radius: 24px !important;
  border: 0px solid;
  width: 20px !important;
  height: 20px;
  text-align: center !important;
  font-size: 14px !important;
  vertical-align: middle;
  line-height: revert;
  cursor: pointer;
}

.temp-message {
  background-color: #0000001f;
  border-radius: 10px;
  padding: 1em;
  font-weight: 600;
  border: 1px solid #00000073;
}

.scrollable-content {
  max-height: 100%;
  overflow-y: auto;
}

.sidebar-item {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999999;
}

@media (max-width: 400px) {
  .range-audio-input {
    width: 4em;
  }
}

@media (max-width: 350px) {
  .range-audio-input {
    display: none;
  }
}

</style>
